import React from "react"
import { Dropdown, DropdownButton } from "react-bootstrap"

import { registration } from "./index"
import { trendFields } from "./GraphFieldTable"

export default function DropdownTrendField({ obv, field, intl, disabled, updateField, id }) {
  const obv_info = trendFields[field]
  if (obv[field] === "box") {
    return <span>registration["box_trend_option"](intl)</span>
  } else {
    let opt_text = obv[field]
    if (obv_info?.optionsRename?.[opt_text]) {
      opt_text = obv_info?.optionsRename?.[opt_text]
    } else if (!opt_text && obv_info?.defaultValue) {
      opt_text = obv_info?.defaultValue
    }
    const is_disabled =
      !obv_info.editable ||
      disabled ||
      (field === "strokeModifier" && ["points", "box"].includes(obv["style"])) ||
      (field === "pointModifier" && ["line", "box"].includes(obv["style"])) ||
      (field === "style" && obv.tag === "Design")
    const key = `${opt_text}_trend_option`
    return !is_disabled ? (
      <DropdownButton
        title={registration[key](intl)}
        variant={"outline-primary"}
        disabled={is_disabled}
        id={id || key}
      >
        {obv_info.options.map((opt) => {
          return (
            <Dropdown.Item
              key={opt}
              name={opt}
              onClick={(ev) => {
                ev.preventDefault()
                updateField(opt)
              }}
            >
              {registration[`${obv_info?.optionsRename?.[opt] || opt}_trend_option`](intl)}
            </Dropdown.Item>
          )
        })}
      </DropdownButton>
    ) : (
      <span>{registration[key](intl)}</span>
    )
  }
}
